const itemGroupToSectorMapping = {
  MOBILE_COMPUTING: 'IT-Office',
  PTV_FLAT: 'Consumer Electronics',
  VACUUM_CLEANERS: 'SDA',
  WASHINGMACHINES: 'MDA',
  MEDIATABLETS: 'IT-Office',
  COOLING: 'MDA',
  DESKBOUND_COMPUTERS: 'IT-Office',
  HOT_BEVER_MAKER: 'SDA',
  MONITORS: 'IT-Office',
  MINIBLUETOOTHSPEAKERS: 'Consumer Electronics',
  FOODPREPARATION: 'SDA',
  DIGITAL_CAMERAS: 'None',
  COOKING: 'MDA',
  GAMING_HEADSETS: 'IT-Office',
  MOB_HEADSET_TOTAL: 'Mobile Phone',
  HEADPHONES_MOB_HEADSETS: 'Mobile Phone',
  SOUNDBAR_BASE: 'Consumer Electronics',
  HEADSETS_TOTAL: 'Mobile Phone',
  VISUAL_CAMS: 'IT-Office',
  ELECTRICAL_COOKING_POTS: 'SDA',
  BUILTINHOBS: 'MDA',
  HAIRDRYERS: 'SDA',
  HAIRSTYLERS: 'SDA',
  TOASTERS: 'SDA',
  DISHWASHERS: 'MDA',
  DEEP_FRYERS: 'SDA',
  LOUDSPEAKERS: 'Consumer Electronics',
  POINTING_DEV: 'IT-Office',
  AUDIO_HOME_SYS: 'Consumer Electronics',
  INKJET_PRINTING_DEVICES: 'IT-Office',
  MICROPHONES: 'IT-Office',
  IRONS: 'SDA',
  DOOR_COMMUNICATION: 'SDA',
  KETTLES: 'SDA',
  KEYING_DEV: 'IT-Office',
  MALESHAVERS: 'SDA',
  BREAST_FEEDING: 'SDA',
  WOODEFFECT: 'None',
  ELECTRIC_COSMETICS: 'None',
  EMULSION_PAINT: 'None',
  ANALOG_DIGITAL_CAMS_SPP: 'None',
  LADIESSHAVERS: 'SDA',
  TUMBLE_DRYERS: 'MDA',
  LIGHT_THERAPY: 'SDA',
  WOOD_FILLERS: 'None',
  EXTERNAL_HDD: 'IT-Office',
  SHAVERS: 'SDA',
  WOODWAX: 'None',
  SSD: 'IT-Office',
  WRIST_WATCHES: 'None',
  TRUCK_TIRES: 'None',
  MEDIABOX_MEDIASTICKS: 'Consumer Electronics',
  VARNISH: 'None',
  DEC_GARDEN_PRES: 'None',
  WEB_CAMS: 'IT-Office',
  MEMORY_CARDS: 'IT-Office',
  WOOD_STAIN: 'None',
  METAL_PAINTS: 'None',
  COMM_DEVICE_ROUTER: 'IT-Office',
  FREEZERS: 'MDA',
  SMARTWATCHES_SIM_NO_SIM: 'Mobile Phone',
  AR_VR_GLASSES: 'Mobile Phone',
  SPECIAL_PAINTS: 'None',
  GAMING_KEYBOARDS: 'IT-Office',
  STEAM_CLEANERS: 'SDA',
  DENTAL_CARE: 'SDA',
  TRIM_PAINT: 'None',
  CAR_TIRES: 'None',
  TRUE_WIRELESS_HEADPHONES: 'Mobile Phone',
  MOVEMENT_DETECTORS: 'None',
  DSC_SLR_COMP_SYS: 'None',
  NET_CAMS: 'IT-Office',
  INTERCHANGEABLE_LENSES: 'None',
  NOTEBOOK_CASES: 'None',
  WATER_FILTERS: 'None',
  PANS: 'SDA',
  WOOD_DYES: 'None',
  PC_VOIP_HEADSETS: 'IT-Office',
  WOOD_OIL: 'None',
  HEADPHONES: 'Mobile Phone',
  WOOD_TREATMENT: 'None',
  POTS: 'SDA',
  CORE_WEARABLES: 'Mobile Phone',
  PRIMER_UNDERCOATS: 'None',
  AIR_TREATMENT: 'SDA',
  MASSAGE: 'SDA',
  SMPPHAB: 'Mobile Phone',
  POWERED_LAWN_MOWERS: 'None',
  POWERED_CHAIN_SAWS: 'None',
  GAMING_MICE: 'IT-Office',
  ROBOT_LAWN_MOWERS: 'SDA',
  POWERED_BLOW_VACS: 'None',
  EL_HEATING: 'None',
  POWERED_HEDGE_TRIMMERS: 'None',
  POWERED_TRIMMERS: 'None',
  HAIRDRYERS_HAIRSTYLERS: 'SDA',
  ROBOT_VACUUM_CLEANERS: 'SDA',
  SYRUP: 'None',
  BABY_BOTTLES_TEATS: 'None',
  POWERTOOLS_18: 'None',
  AMPLIFIER_RECEIVER: 'Consumer Electronics',
  BOTTLE_WAR_STERI: 'None',
  BABY_SOOTHERS: 'None',
  SECURITY_SOFTWARE: 'IT-Office',
  SODAMAKERS: 'None',
  PHONE_DEVICE: 'Mobile Phone',
  TOOL_BATTERIES_CHARGERS: 'None',
  DATA_VIDEO_PROJECTORS: 'Consumer Electronics',
  E_BOARDS: 'None',
  GIFT_BOXES: 'None',
  HAIR_CARE_TOTAL: 'SDA',
  HAIRCLIPPERS: 'SDA',
  MOBCOMP_MEDIATAB: 'IT-Office',
  ELECTRIC_OUTDOOR_BBQ: 'None',
  FINANCIAL_SOFTWARE: 'None',
  BABY_TABLEWARE: 'None',
  OUTDOOR_BBQ: 'None',
  BABY_MONITORS: 'None',
  BABY_TEETHERS: 'None',
  DOCUMENT_SHREDDERS: 'IT-Office',
  MOBILE_ENHANCEMENT: 'Mobile Phone',
  PLAN_ADAPTER: 'None',
  KITCHEN_FURNITURE: 'None',
  REPEATER: 'IT-Office',
  COMM_DEVICE_ROUTER_INCL_PBX: 'IT-Office',
  CONSOLE_HEADSETS: 'Mobile Phone',
  TAPS: 'None',
  SMPPHAB_NV: 'Mobile Phone',
  AIRCONDITIONING: 'MDA',
  SMPPHAB_BV: 'Mobile Phone',
  BICYCLES: 'None',
  HOODS: 'MDA',
  E_BIKES: 'None',
  COMMUNICATION_DEVICES: 'IT-Office',
  WOOD_PAINT: 'None',
  WINE_CABINETS: 'None',
  MICROWAVE_OVENS: 'MDA',
  SMPPHAB_ASP: 'Mobile Phone',
  HEADPHONES_HEADSETS: 'Mobile Phone',
  DRINK_CHILLERS: 'None',
  HBMESPRFCSS: 'None',
  SMPPHAB_OV: 'Mobile Phone',
  DESKBOUND_COMPUTERS_JP: 'IT-Office',
  CAMCORDERS: 'None',
  RICE_COOKERS: 'MDA',
  MINI_OVENS: 'MDA',
  BEDSTEADS: 'None',
  RESTING_SETS: 'None',
  MATTRESSES: 'None',
  LIQUIDISERS: 'MDA',
  HANDSTICK_VACUUM_CLEANERS: 'SDA',
  COMPACT_RADIO: 'None',
  DRY_BATTERIES: 'None',
  EL_WATER_HEATERS: 'SDA',
  GAS_WATER_HEATERS: 'SDA',
  DESKBOUND_COMPUTING_INDIA: 'IT-Office',
  MOTORCYCLE_TIRES: 'None',
  TAIWAN_PTV_VOD_MONITOR: 'Consumer Electronics',
  DESKBOUND_COMPUTING_TAIWAN: 'IT-Office',
  GAMING_MOBILE_COMPUTING: 'IT-Office',
  DESKBOUND_COMPUTING_SOUTHKOREA: 'IT-Office',
  KIMCHI_REFRIGERATORS: 'MDA',
  DESKBOUND_COMPUTING_THAILAND: 'IT-Office',
  DESKBOUND_COMPUTING_CHINA: 'IT-Office',
  DESKBOUND_COMPUTING_MALAYSIA: 'IT-Office',
  DESKBOUND_COMPUTING_VIETNAM: 'IT-Office',
  DESKBOUND_COMPUTING_INDONESIA: 'IT-Office',
  GARMENT_STEAMERS: 'SDA',
  DESKBOUND_COMPUTERS_HONG_KONG: 'IT-Office',
  LED_LAMPS: 'None',
  VIDEO_GAMES_HARDWARE: 'IT-Office',
  LASER_PRINTING_DEVICES: 'IT-Office',
  DESKBOUND_COMPUTING_SINGAPORE: 'IT-Office',
  DESKBOUND_COMPUTING_PHILIPPINES: 'IT-Office',
  HBMESPRFA: 'None',
  HBMESPRPT: 'None',
  PRINTING: 'IT-Office',
  SMPPHAB_OPEN_MARKET: 'Mobile Phone',
};

const getSectorByItemGroupCode = (itemGroupCode: string): string | undefined => itemGroupToSectorMapping[itemGroupCode];

export default getSectorByItemGroupCode;
